const EXTERNAL_PUBLISHER_USERNAME = "gonzalo@edify.la";

const normalize = (value?: string | null) => (value ?? "").trim().toLowerCase();

export const isExternalPublisherUsername = (username?: string | null) => {
  return normalize(username) === EXTERNAL_PUBLISHER_USERNAME;
};

export const isExternalWorkOffer = (workOffer?: {
  user?: {
    username?: string | null;
    email?: string | null;
  } | null;
} | null) => {
  return (
    isExternalPublisherUsername(workOffer?.user?.username) ||
    isExternalPublisherUsername(workOffer?.user?.email)
  );
};
